export default __webpack_public_path__ + "src/pages/Reports/pages/OverviewMap/components/WelcomeModal/GridChilds/assets/kataster.jpg";